import ListProcesses from "@/views/packing_house/production/palletized/ListProcesses.vue";
import ShowProcess from "@/views/packing_house/production/palletized/ShowProcess.vue";
import ShowProcessPackageGroups from "@/components/views/packing_house/production/palletized/show_process/PackageGroups.vue";
import ShowProcessPackagesFromStock from "@/components/views/packing_house/production/palletized/show_process/PackagesFromStock.vue";
import NewPackageGroup from "@/views/packing_house/production/palletized/NewPackageGroup.vue";
import ShowPackageGroup from "@/views/packing_house/production/palletized/ShowPackageGroup.vue";
import EditPackageGroup from "@/views/packing_house/production/palletized/EditPackageGroup.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "production",
  permission: "palletized",
});

export default [
  {
    path: "/ph/:packing_house_id/production/palletized/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/production/palletized/show_process/:packing_house_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_package_groups") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "package_groups",
        name: routeName("show_process_package_groups"),
        component: ShowProcessPackageGroups,
        props: true,
        meta: META,
      },
      {
        path: "packages_from_stock",
        name: routeName("show_process_packages_from_stock"),
        component: ShowProcessPackagesFromStock,
        props: true,
        meta: META,
      },
    ],
  },
  {
    path: "/ph/:packing_house_id/production/palletized/new_package_group/:packing_house_process_id",
    name: routeName("new_package_group"),
    component: NewPackageGroup,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/production/palletized/show_package_group/:packing_house_process_id/:id",
    name: routeName("show_package_group"),
    component: ShowPackageGroup,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/production/palletized/edit_package_group/:packing_house_process_id/:id",
    name: routeName("edit_package_group"),
    component: EditPackageGroup,
    props: true,
    meta: META,
  },
];
